var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"now"},[_c('span',{staticClass:"nowYear"},[_vm._v(_vm._s(_vm.getYear))]),_c('span',{staticClass:"nowDate"},[_vm._v(_vm._s(_vm.getCurrentDate))])])
}
var staticRenderFns = []

export { render, staticRenderFns }